class PreDefinedNote {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allPreDefinedNotes: [],
      preDefinedNote: new PreDefinedNote(''),
      allPreDefinedNotesForOther: [],
    };
  },
  methods: {
    getListOfPreDefinedNotes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPreDefinedNotes').then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.allPreDefinedNotesForOther =
            this.$store.state.preDefinedNoteModule.allPreDefinedNotes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfPreDefinedNotes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfPreDefinedNotes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPreDefinedNotes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPreDefinedNotes').then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.allPreDefinedNotes = this.$store.state.preDefinedNoteModule.allPreDefinedNotes;
          this.allPreDefinedNotes.forEach((c) => (c.isEdit = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllPreDefinedNotes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllPreDefinedNotes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPreDefinedNoteFunction: function () {
      if (!this.preDefinedNote.title) {
        this.snackText = 'متن توضیح نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.preDefinedNote.title.replace(/\s/g, '').length) {
        this.snackText = 'متن توضیح نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPreDefinedNote', this.preDefinedNote).then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' توضیح با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.preDefinedNote = new PreDefinedNote('');
          this.getAllPreDefinedNotes();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addPreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addPreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPreDefinedNoteFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPreDefinedNote', id).then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.preDefinedNote = this.$store.state.preDefinedNoteModule.preDefinedNote;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPreDefinedNoteFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getPreDefinedNoteFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editPreDefinedNoteFunction: function () {
      if (!this.preDefinedNote.title) {
        this.snackText = 'متن توضیح نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.preDefinedNote.title.replace(/\s/g, '').length) {
        this.snackText = 'متن توضیح نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editPreDefinedNote', this.preDefinedNote).then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllPreDefinedNotes();
          this.snackText = ' توضیح با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.preDefinedNote = new PreDefinedNote('');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editPreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editPreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePreDefinedNoteFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePreDefinedNote', this.preDefinedNoteId).then(() => {
        if (this.$store.state.preDefinedNoteModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllPreDefinedNotes();
          this.snackText = ' توضیح با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.preDefinedNoteModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.preDefinedNoteModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deletePreDefinedNoteFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.preDefinedNoteModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
